import { combineReducers } from "redux";

// Front
import LayoutReducer from "./other/layouts/reducer";

import authSlice from "./apps/authSlice";
import companySlice from "./apps/companySlice";
import userSlice from "./apps/userSlice";
import customerSlice from "./apps/customerSlice";
import orderSlice from "./apps/orderSlice";

const rootReducer = combineReducers({
  Layout: LayoutReducer,

  auth: authSlice,
  company: companySlice,
  customer: customerSlice,
  order: orderSlice,
  user: userSlice,
});

export default rootReducer;
